"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.singleValue = singleValue;
exports.dictionary = dictionary;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function singleValue(func) {
    var cache = void 0;
    return {
        getValue: function getValue() {
            return cache || (cache = func());
        },
        reset: function reset() {
            cache = null;
        }
    };
}

function dictionary(func) {
    var cache = new Map();
    var reverseOutdated = false;
    var reverseCache = new Map();
    var updateReverse = function updateReverse() {
        if (reverseOutdated) {
            reverseCache = new Map([].concat(_toConsumableArray(cache)).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    a = _ref2[0],
                    b = _ref2[1];

                return [b, a];
            }));
        }
        reverseOutdated = false;
    };
    return {
        getValue: function getValue(key) {
            if (cache.has(key)) {
                return cache.get(key);
            }
            var value = func(key);
            if (value === key) {
                return value;
            }
            cache.set(key, value);
            reverseOutdated = true;
            return value;
        },
        delete: function _delete() {
            cache.delete.apply(cache, arguments);
            reverseOutdated = true;
        },
        reset: function reset() {
            cache.clear();
            reverseCache.clear();
        },
        keys: function keys() {
            return Array.from(cache.keys());
        },
        values: function values() {
            updateReverse();
            return Array.from(reverseCache.keys());
        },
        getKey: function getKey(value) {
            updateReverse();
            if (reverseCache.has(value)) {
                return reverseCache.get(value);
            }
            return value;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/cachedValue.js
// module id = 164
// module chunks = 1